import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { User } from 'react-feather';

function Layout({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAuthenticated = !!localStorage.getItem('jwt');
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const isGod = localStorage.getItem('isGod') === 'true';
  const isOwner = localStorage.getItem('isOwner') === 'true';
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    setUser(userData);

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleDropdownToggle = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    // Redirect to login or home page
  };

  return (
    <div className="min-h-screen bg-neutral-800 text-white">
      <header className="bg-sky-200">
        <nav className="flex flex-col md:flex-row justify-between items-center p-4 bg-neutral-900 text-white">
          <div className="w-full md:w-auto flex flex-row md:flex-col justify-between items-center">
              <Link to="/" className="flex items-center mr-4">
                <img src="/images/logo64.png" alt="Logo" className="h-8 w-8 mr-2" />
                <span className="text-white font-bold">DevWing</span>
              </Link>
              <button
                className="text-white md:hidden"
                onClick={toggleMenu}
              >
                ☰
              </button>
          </div>
          <div className={`${isMenuOpen ? 'flex' : 'hidden'} w-full mt-2 md:mt-0 md:ml-6 md:flex md:flex-col`}>
            <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6 text-left items-center">
              {!isAuthenticated && (
                <li>
                  <Link to="/" className="hover:text-sky-300">Home</Link>
                </li>
              )}
              <li>
                <Link to={isAuthenticated ? '/dashboard' : '/login'} className="hover:text-sky-300">
                  {isAuthenticated ? 'Home' : 'Login'}
                </Link>
              </li>
              {isAuthenticated && isAdmin && (
                <>
                  <li>
                    <Link to="/snapshots" className="hover:text-sky-300">Snapshots</Link>
                  </li>
                </>
              )}
              {isAuthenticated && isOwner && (
                <>
                  <li>
                    <Link to="/users" className="hover:text-sky-300">Users</Link>
                  </li>
                  <li>
                    <Link to="/teams" className="hover:text-sky-300">Teams</Link>
                  </li>
                </>
              )}
              {isAuthenticated && isGod && (
                <>
                  <li>
                    <Link to="/topics" className="hover:text-sky-300">Topics</Link>
                  </li>
                  <li>
                    <Link to="/questions" className="hover:text-sky-300">Questions</Link>
                  </li>
                  <li>
                    <Link to="/organizations" className="hover:text-sky-300">Organizations</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
          {isAuthenticated && (
            <div className="relative ml-auto">
              <button
                className="flex items-center justify-center w-8 h-8 rounded-full bg-sky-500 hover:bg-sky-700 transition text-white"
                onClick={handleDropdownToggle}
              >
                <User color="white" size={16} />
              </button>
              {dropdownOpen && (
                <div ref={dropdownRef} className="absolute right-0 mt-2 w-48 bg-black text-white rounded shadow-lg">
                  <ul className="py-1">
                    <li className="font-bold px-4 pt-2">
                      <span>{user.name}</span>
                    </li>
                    {user.organizations && user.organizations.length > 0 && user.organizations.map((org) => (
                      org.active && (
                        <li key={org.id} className="font-semibold text-xs px-4 pb-2">
                          <span>{org.name}</span>
                        </li>
                      )
                    ))}
                    
                    <li className="border-t border-neutral-700">
                      <Link to="/settings" className="block px-4 py-2 hover:bg-sky-500">Settings</Link>
                    </li>
                    <li>
                      <Link to="/logout" className="block px-4 py-2 hover:bg-sky-500">Logout</Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            )}
        </nav>
      </header>
      <main className="container mx-auto p-8">
        {children}
      </main>
    </div>
  );
}

export default Layout;
